import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type {
  GetEmailIngestorByIdPayload,
  GetEmailIngestorByIdResponse,
  GetEmailIngestorByIdResponseActionPayload,
} from 'client/js/redux/domains/EmailIngestor/EmailIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';

const GetIngestorById = new ReduxAsyncAction<
  'EMAIL_INGESTOR_GET_INGESTOR_BY_ID',
  GetEmailIngestorByIdPayload,
  GetEmailIngestorByIdResponseActionPayload | undefined
>('EMAIL_INGESTOR_GET_INGESTOR_BY_ID');

GetIngestorById.registerRequest(async (payload) => {
  try {
    const { id } = payload;
    const response = await dash_api.get<GetEmailIngestorByIdResponse>(`/v1/roi/email-ingestors/${id}`);
    return {
      data: response.data,
    };
  } catch (error) {
    NotificationActions.showNotification('Error occurred while fetching email importer', 'error');
    throw error;
  }
});

export const GET_EMAIL_INGESTOR_BY_ID = GetIngestorById.actionNamespaceConstants;

export const getEmailIngestorById = GetIngestorById.request;

export type GetEmailIngestorByIdResponseAction = Action<typeof GET_EMAIL_INGESTOR_BY_ID.response> & {
  data: GetEmailIngestorByIdResponseActionPayload;
};
